import type { z } from 'zod';

import { booleanFormSchema, numericStringFormSchema } from '@/_schemas/generic';

import { inventoryVolumeUpdateSchema } from './inventory-volumes-mutation-schema';

export const inventoryVolumeFormSchema = inventoryVolumeUpdateSchema.extend({
  quantity: numericStringFormSchema().min(1),
  primary: booleanFormSchema(),
});

export type InventoryVolumeFormSchema = z.infer<typeof inventoryVolumeFormSchema>;
